import * as actions from './actions';
import * as hooks from './hooks';
import * as reducers from './reducers';
/**
 * Encapsulates all common functionality regarding Ghost articles.
 *
 * Using this model will allow you to easily add Ghost articles to your product, without need much (if any) custom code beyond basic configuration.
 *
 * ```js
 * import { ghost } from '@minerva-analytics/pantheon;
 *
 * console.log(ghost);
 * {
 *   actions: {
 *     getArticle,
 *     getArticleStart,
 *     getArticleSuccess,
 *     getArticleFailure,
 *     getArticles,
 *     getArticlesStart,
 *     getArticlesSuccess,
 *     getArticlesFailure,
 *     selectArticle,
 *   },
 *   reducers: {
 *     byId,
 *     getArticleStatus,
 *     getArticlesStatus,
 *     selected,
 *   },
 *   hooks: {
 *     useGhostActions,
 *     useSelectedArticle,
 *   }
 * }
 * ```
 */

export var ghost = {
  actions: actions,
  hooks: hooks,
  reducers: reducers
};